import { useLocation } from "react-router-dom";
/**
 * This hook returns the query params from url
 */
export function useQuery() {
  return new URLSearchParams(useLocation().search);
}
